<template>
  <v-container xs12 md12 lg12 xl12 pa-0>
    <v-layout wrap align-center justify-center>
      <v-flex xs12>
        <Breadcrumbs :items="breadcrumbs"/>
      </v-flex>
      <v-flex xs12 align-content-center justify-center>
        <v-card>
          <v-tabs fixed-tabs v-model="tab">
            <v-tab
              v-for="tabItem in tabItems"
              :key="tabItem.title"
              :to="tabItem.path">
              {{ $vuetify.t(tabItem.title) }}
            </v-tab>
          </v-tabs>

          <v-card class="admin-router-view" flat>
              <v-layout justify-center align-content-center>
                <v-flex lg12 xl10>
                  <router-view/>
                </v-flex>
              </v-layout>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import Breadcrumbs from './Breadcrumbs'
import IdeaSpaceAdmin from './IdeaSpaceAdmin'
import PagesAdmin from './PagesAdmin'
import LinksAdmin from './LinksAdmin'
import Phase from './Phase'
import Quorum from './Quorum'
import Categories from './Categories'
import Vacation from './Vacation'
import GroupsUsers from './GroupsUsers'
import School from './School'
import RoleEdit from './RoleEdit'

export default {
  name: 'Admin',
  components: {
    Breadcrumbs,
    IdeaSpaceAdmin,
    PagesAdmin,
    LinksAdmin,
    Phase,
    Quorum,
    Categories,
    Vacation,
    GroupsUsers,
    School,
    RoleEdit
  },
  data: function () {
    return {
      tab: null,
      tabItems: [
        {title: '$vuetify.AdminMenu.users', path: '/admin/users'},
        {title: '$vuetify.AdminMenu.roleEdit', path: '/admin/roleEdit'},
        {title: '$vuetify.AdminCommunity.community', path: '/admin/community'},
        {title: '$vuetify.AdminMenu.pages', path: '/admin/pages'},
        {title: '$vuetify.AdminLinks.links', path: '/admin/links'},
        {title: '$vuetify.AdminMenu.ideaSpace', path: '/admin/ideaSpace'},
        {title: '$vuetify.AdminMenu.phaseDuration', path: '/admin/phaseDuration'},
        {title: '$vuetify.AdminMenu.categories', path: '/admin/categories'},
        {title: '$vuetify.AdminMenu.quorum', path: '/admin/quorum'}
      ],
      breadcrumbs: [
        {
          title: 'aula',
          to: '/'
        },
        {
          title: this.$vuetify.t('$vuetify.AdminMenu.title'),
          to: this.$route.path
        }
      ]
    }
  },

  computed: {
    hasSelectedSchool: function () {
      return this.$store.getters.selected_school >= 0
    }
  },

  props: {},

  methods: {}
}
</script>
<style lang="scss">
.save-button {
  background-color: var(--v-primary-lighten1) !important;
}

.admin-router-view {
  min-height: 80vh;
}
</style>
